import React, { useContext, useState, useEffect } from "react";
import { auth } from "../../firebase-service/firebaseSetup";
// import { GoogleAuthProvider } from "firebase/auth";
import { onAuthStateChanged } from "firebase/auth";
import { getFantasyParticipantes } from '../../firebase-service/firebaseService.js'


const AuthContext = React.createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [actualParticipante, setCurrentParticipante] = useState(null);
  const [userLoggedIn, setUserLoggedIn] = useState(false);
  const [isEmailUser, setIsEmailUser] = useState(false);
  const [isGoogleUser, setIsGoogleUser] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, initializeUser);
    return unsubscribe;
  }, []);

  async function initializeUser(user) {
    if (user) {

      setCurrentUser({ ...user });

      esperarPorParticipante(user)

      // check if provider is email and password login
      const isEmail = user.providerData.some(
        (provider) => provider.providerId === "password"
      );
      setIsEmailUser(isEmail);

      // check if the auth provider is google or not
    //   const isGoogle = user.providerData.some(
    //     (provider) => provider.providerId === GoogleAuthProvider.PROVIDER_ID
    //   );
    //   setIsGoogleUser(isGoogle);

      setUserLoggedIn(true);
    } else {
      setCurrentUser(null);
      setCurrentParticipante(null);
      setUserLoggedIn(false);
    }

    setLoading(false);
  }

  const esperarPorParticipante = async (user) => {
    getFantasyParticipantes(resp => {
        if (resp.length > 0) { 
            resp = resp.find((a) => a.id == user.uid)
            setCurrentParticipante({...resp})
        }
        if (resp.length === 0) { setCurrentParticipante(null) }
    }, (resp, err) => { console.error(resp, err) })
  };
  

  const value = {
    userLoggedIn,
    isEmailUser,
    isGoogleUser,
    currentUser,
    actualParticipante,
    setCurrentUser,
    setCurrentParticipante
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}